import React, { useState } from "react";
import classes from "./SubscribeNow.module.scss";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import { INTEREST_TEXT } from "../../../utils/constants";

const SubscribeNow: React.FC = () => {
  const [mail, setMail] = useState<string>("");
  const [intrestedIn, setIntrestedIn] = useState<string>("");
  const [intrestError, setIntrestError] = useState<boolean>(false);

  const onSubmitStatus = (message: string | Error | null, stat: string) => {
    setMail("");
    setIntrestedIn(INTEREST_TEXT);
    return <div style={{ color: stat === "error" ? "red" : "green" }}>{message}</div>;
  };

  return (
    <div className={classes.about}>
      <h3>Stay updated with KC Overseas</h3>
      <MailchimpSubscribe
        url={process.env.NEXT_PUBLIC_MAILCHIMP_URL || "/"}
        render={({ subscribe, status, message }) => (
          <div>
            <form
              onSubmit={(e: any) => {
                e.preventDefault();
                intrestedIn === INTEREST_TEXT && setIntrestError(true);
                if (mail && intrestedIn && intrestedIn !== INTEREST_TEXT) {
                  // @ts-ignore
                  subscribe({ EMAIL: mail, MMERGE1: intrestedIn });
                }
              }}
            >
              <div className={classes.subscribeForm}>
                <div>
                  <Form.Control
                    id="emailFooter"
                    type="email"
                    placeholder="Email ID"
                    required
                    value={mail}
                    onChange={(event: any) => setMail(event.target.value)}
                  />
                </div>
                <div>
                  <Form.Select
                    id="formselect"
                    required
                    onChange={(event: any) => {
                      setIntrestError(false);
                      setIntrestedIn(event.target.value);
                    }}
                    aria-label="I'm intrested in"
                  >
                    <option value="">{INTEREST_TEXT}</option>
                    <option>Student</option>
                    <option>Institute</option>
                    <option>Partner</option>
                    <option>Franchisee</option>
                  </Form.Select>
                  {intrestError && <Form.Text style={{ color: "red" }}>Please select this field</Form.Text>}
                </div>
                <div>
                  <button type="submit" disabled={status === "sending"}>
                    Subscribe Now
                    {status === "sending" && (
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" style={{ margin: "0 0 2px 5px" }} />
                    )}
                  </button>
                </div>
              </div>
            </form>
            {(status === "error" || status === "success") && onSubmitStatus(message, status)}
          </div>
        )}
      />
    </div>
  );
};

export default SubscribeNow;
